import { useState } from 'react';

// Stockage EN MÉMOIRE (module) : survit aux changements d'onglet, perdu au rechargement de la page.
// Volontairement pas de localStorage (exigence : aucune persistance).
const store = new Map(); // address -> trigger[]

const FIELDS = [
  ['liquiditeMin', 'Liquidité min ($)'], ['liquiditeMax', 'Liquidité max ($)'],
  ['mcapMin', 'Market cap min ($)'], ['mcapMax', 'Market cap max ($)'],
  ['positionMin', 'Position min ($)'], ['roiMin', 'ROI min (%)'], ['dureeMax', 'Durée max (min)'],
];
const EMPTY = { name: '', liquiditeMin: '', liquiditeMax: '', mcapMin: '', mcapMax: '', positionMin: '', roiMin: '', dureeMax: '' };

function describe(t) {
  const parts = FIELDS.filter(([k]) => t[k] !== '' && t[k] != null).map(([k, l]) => `${l} ${t[k]}`);
  return parts.length ? parts.join(' ET ') : 'Aucune condition';
}

export default function TriggersTab({ address, walletName }) {
  const [list, setList] = useState(() => store.get(address) || []);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [err, setErr] = useState('');
  const [confirmDel, setConfirmDel] = useState(null);

  const commit = (next) => { store.set(address, next); setList(next); };
  const set = (k, v) => { setForm(f => ({ ...f, [k]: v })); setErr(''); };

  const save = () => {
    if (!form.name.trim()) { setErr('Le nom du trigger est obligatoire.'); return; }
    if (editId) commit(list.map(t => (t.id === editId ? { ...t, ...form } : t)));
    else commit([...list, { ...form, id: `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, active: true }]);
    setForm(EMPTY); setEditId(null);
  };
  const edit = (t) => { setEditId(t.id); setForm({ ...EMPTY, ...t }); setErr(''); };
  const cancel = () => { setEditId(null); setForm(EMPTY); setErr(''); };

  return (
    <div className="an-stack">
      <div className="an-panel an-explain">
        <div className="an-section-title"><span className="an-section-icon">⚡</span>Triggers de copytrade</div>
        <div className="an-explain-box">
          <div><b>SI</b> <b>{walletName}</b> achète un token</div>
          <div><b>ET</b> que toutes les conditions ci-dessous sont remplies</div>
          <div><b>ALORS</b> le trigger est déclenché (simulation — ces règles ne sont pas enregistrées et disparaissent au rechargement de la page).</div>
        </div>
      </div>

      <div className="an-panel">
        <div className="an-section-title">{editId ? 'Modifier le trigger' : 'Nouveau trigger'}</div>
        <div className="an-field">
          <span className="an-field-label">Nom *</span>
          <input className="an-input" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Ex : Petites caps rapides" />
        </div>
        <div className="an-trig-grid">
          {FIELDS.map(([k, l]) => (
            <div className="an-field" key={k}>
              <span className="an-field-label">{l}</span>
              <input className="an-input an-input--sm" type="number" value={form[k]} onChange={e => set(k, e.target.value)} />
            </div>
          ))}
        </div>
        <div className="an-preview"><span className="an-muted">Aperçu :</span> SI {walletName} achète ET {describe(form)}</div>
        {err && <div className="an-error-inline">{err}</div>}
        <div className="an-btn-row">
          <button className="an-btn an-btn--accent" onClick={save}>{editId ? 'Enregistrer' : 'Créer le trigger'}</button>
          {editId && <button className="an-btn an-btn--ghost" onClick={cancel}>Annuler</button>}
        </div>
      </div>

      <div className="an-panel">
        <div className="an-section-title">Triggers ({list.length})</div>
        {list.length === 0 && <p className="an-empty-inline">Aucun trigger pour ce wallet.</p>}
        {list.map(t => (
          <div key={t.id} className={`an-trig${t.active ? '' : ' an-trig--off'}`}>
            <div className="an-trig-main">
              <div className="an-trig-name">{t.name}</div>
              <div className="an-muted an-small">{describe(t)}</div>
            </div>
            <div className="an-trig-actions">
              <label className="an-toggle" title={t.active ? 'Actif' : 'En pause'}>
                <input type="checkbox" checked={t.active} onChange={() => commit(list.map(x => (x.id === t.id ? { ...x, active: !x.active } : x)))} />
                <span className="an-toggle-track" />
              </label>
              <button className="an-btn an-btn--ghost an-btn--sm" onClick={() => edit(t)}>✏️</button>
              {confirmDel === t.id
                ? <>
                    <button className="an-btn an-btn--danger an-btn--sm" onClick={() => { commit(list.filter(x => x.id !== t.id)); setConfirmDel(null); }}>Confirmer</button>
                    <button className="an-btn an-btn--ghost an-btn--sm" onClick={() => setConfirmDel(null)}>Non</button>
                  </>
                : <button className="an-btn an-btn--ghost an-btn--sm" onClick={() => setConfirmDel(t.id)}>🗑</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
